import {PropsWithChildren, forwardRef} from "react";
import {
	ModalOverlayProps,
	ModalOverlay as Overlay,
} from "react-aria-components";
import clsMerge from "../util/clsMerge";
import {m} from "framer-motion";

// somebody explain the typing on this to me because i...just used whatever worked
const ModalOverlay: React.FC<PropsWithChildren<ModalOverlayProps>> = forwardRef<
	HTMLDivElement,
	PropsWithChildren<ModalOverlayProps>
>(function ModalOverlay(props, ref) {
	const {children, className, ...modalProps} = props;
	return (
		<Overlay
			className={clsMerge(
				"fixed top-0 z-modal flex h-screen max-h-dvh w-screen flex-col items-center justify-center bg-gray-900 bg-opacity-40 backdrop-blur-sm",
				className
			)}
			ref={ref}
			{...modalProps}
		>
			{children}
		</Overlay>
	);
});

export default m(ModalOverlay);
